import { unref } from 'vue';

import { useI18n } from '@modules/i18n/composables';

import { TRANSLATION_GROUP_AFFILIATES_APPROVED } from '../constants';

export interface IAffiliatesTranslateComposable {
  translate(shortCode: string): string;
}
export default function useAffiliatesTranslate(): IAffiliatesTranslateComposable {
  const { getTranslation } = useI18n();

  function translate(shortCode: string): string {
    return unref(getTranslation(TRANSLATION_GROUP_AFFILIATES_APPROVED, shortCode));
  }

  return {
    translate,
  };
}
